import {useEffect, useState} from "react"
import {BaSeIcon} from "@base/react";
import "./index.scss"

const SideModal = ({
                     show = false,
                     title,
                     children,
                     callBackClose,
                     square = false,
                     disableCloseBackdrop = false,
                     hideBackdrop = false,
                     footer = null,
                     width = null,
                     classCustom = ''
                   }) => {
  const [showModal, setShowModal] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)

  const closeModal = () => {
    setShowModal(false)
    setTimeout(() => {
      setShouldRender(false)
      if (callBackClose) callBackClose()
    }, 200)
  }

  useEffect(() => {
    if (show) {
      setShouldRender(true)
      
      requestAnimationFrame(() => {
        const modalElement = document.querySelector('.side-modal__wrapper-modal')
        if (modalElement) {
          void modalElement.offsetHeight
        }
        
        requestAnimationFrame(() => {
          setShowModal(true)
        })
      })
    } else if (shouldRender) {
      closeModal()
    }
    // eslint-disable-next-line
  }, [show])

  useEffect(() => {
    showModal
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "")
  }, [showModal])

  if (!shouldRender) return null

  return (
    <div className={"side-modal " + classCustom + (showModal ? " open" : "")}>
      {
        !hideBackdrop ? (
          <div onClick={() => !disableCloseBackdrop ? closeModal() : false} className="side-modal__close-page"></div>
        ) : ''
      }
      <div className="side-modal__wrapper-modal" style={{ maxWidth: width ? width : '640px' }}>
        <div className="side-modal__content">
          <div className="side-modal__header">
            <button className="side-modal__btn-close" onClick={() => closeModal()}>
              <BaSeIcon
                color="#005EB8"
                description="Close"
                name="close"
                size={23}
              />
            </button>
            {
              title ? (
                <h3 className={`side-modal__title ${square ? "square-title" : ""} `}>
                  {title}
                </h3>
              ) : ''
            }
          </div>
          <div className="side-modal__body">
            {children}
          </div>
          {
            footer ? (
              <div className="side-modal__footer">
                {footer}
              </div>
            ) : ''
          }
        </div>
      </div>
    </div>
  )
}

export default SideModal;
